require("core-js/modules/es6.regexp.replace");

require("core-js/modules/es6.array.for-each");

var _classCallCheck = require("/opt/build/repo/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/build/repo/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/opt/build/repo/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/opt/build/repo/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/opt/build/repo/node_modules/@babel/runtime/helpers/inherits");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = require("react");

var WPGHtmlBlock =
/*#__PURE__*/
function (_React$Component) {
  "use strict";

  _inherits(WPGHtmlBlock, _React$Component);

  function WPGHtmlBlock() {
    var _this;

    _classCallCheck(this, WPGHtmlBlock);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(WPGHtmlBlock).apply(this, arguments));
    _this.id = Math.floor(Math.random() * 100000);
    return _this;
  }

  _createClass(WPGHtmlBlock, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      document.querySelectorAll("[data-script=\"".concat(this.id, "\"]")).forEach(function (script) {
        window.eval(script.innerHTML);
      });
    }
  }, {
    key: "render",
    value: function render() {
      var innerHTML = this.props.innerHTML;
      var scriptHtml = innerHTML.replace(/<script(>|\s)/gm, "<script data-script=\"".concat(this.id, "\"$1"));
      return React.createElement("div", {
        className: "wpg-block wpg-b_html",
        dangerouslySetInnerHTML: {
          __html: scriptHtml
        }
      });
    }
  }]);

  return WPGHtmlBlock;
}(React.Component);

exports["default"] = WPGHtmlBlock;